module.exports = __webpack_public_path__ + "static/media/joyable7_preview.a02f5d7c.jpg";